// Connecting a social account runs its OAuth flow in another tab (see
// `authorize` in hooks/useSocialProviderAccounts.tsx). The provider lands
// that tab on /auth/callback/[provider], which saves the token, tells the
// tab that started it how it went over SOCIAL_CONNECT_CHANNEL (and
// `window.opener.postMessage`), and closes itself on success;
// useConnectAccountPoll listens. The opener can't just watch the window's
// `closed`: Google's pages (COOP) cut the opener link, so it reads true
// almost at once.
export const SOCIAL_CONNECT_CHANNEL = "klap-social-connect";
export const SOCIAL_CONNECT_MESSAGE_TYPE = "klap-social-connect";

export type SocialConnectMessage = {
  type: typeof SOCIAL_CONNECT_MESSAGE_TYPE;
  status: "connected" | "failed";
  provider: string;
  // Per notify: the opener can get the same one over both channels.
  id: string;
};

export const isSocialConnectMessage = (
  data: unknown,
): data is SocialConnectMessage =>
  !!data &&
  typeof data === "object" &&
  (data as { type?: unknown }).type === SOCIAL_CONNECT_MESSAGE_TYPE;

// Tells the tab that started the connect (useConnectAccountPoll) that it's
// over, so it refetches its accounts and stops polling. Both channels:
// BroadcastChannel survives Google's pages cutting the opener link;
// postMessage covers browsers without BroadcastChannel.
export const notifySocialConnect = (
  status: SocialConnectMessage["status"],
  provider: string
) => {
  const message: SocialConnectMessage = {
    type: SOCIAL_CONNECT_MESSAGE_TYPE,
    status,
    provider,
    id: `${Date.now()}-${Math.random().toString(36).slice(2)}`,
  };
  try {
    const channel = new BroadcastChannel(SOCIAL_CONNECT_CHANNEL);
    channel.postMessage(message);
    channel.close();
  } catch {
    // No BroadcastChannel: postMessage below.
  }
  try {
    window.opener?.postMessage(message, window.location.origin);
  } catch {
    // Opener gone or cross-origin.
  }
};
